// Libs
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

// Utils
import { PATHS } from '~fpu/config/constants';

interface EveryDollarTrialEligibilityResponse {
  data: {
    isEligibleForTrial: boolean;
    isEveryDollarPremiumSubscriber: boolean;
    hasTrialBeenActivated: boolean;
  };
}

function fetchEveryDollarTrialEligibility() {
  return axios.get(PATHS.API.EVERYDOLLAR_TRIAL_ELIGIBILITY);
}

function useEveryDollarTrialEligibility() {
  return useQuery({
    queryKey: ['everydollar-trial-eligibility'],
    queryFn: () => fetchEveryDollarTrialEligibility(),
    select: (data: EveryDollarTrialEligibilityResponse) => data.data
  });
}

export { useEveryDollarTrialEligibility };
